export default "__VITE_ASSET__y5N1aE13__"